import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@api/client/apiClient';
import { queryKeys } from '@api/queryKeys';
import type { UpdateOperation } from '../types';

interface OnDemandInput {
  cellIds?: string[];
  source: string;
}

export function useCreateOnDemand() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: OnDemandInput) =>
      apiClient.post<UpdateOperation>('/updates/requests', input),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.updates.operations });
    },
  });
}
